var version = {
    "name":      "dativery",
    "buildDateCode": "20260803-142707",
    "buildDate": "Mon Aug 03 2026 14:27:07 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260803-142707",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;